import React from 'react';

import { getDisplayName } from './getDisplayName';
import { findElement } from './findElement';

type NameOrComponent =
    | string
    | RegExp
    | React.ReactNode
    | React.ComponentType<any> // eslint-disable-line @typescript-eslint/no-explicit-any
    | React.ForwardRefExoticComponent<React.RefAttributes<unknown>>;

export function isElementOfComponent(
    element: React.ReactNode,
    nameOrComponent: NameOrComponent | NameOrComponent[],
    {
        maxDepth = undefined,
        diveIntoChildren = true,
        onlySingleChildren = true,
    }: { maxDepth?: number; diveIntoChildren?: boolean; onlySingleChildren?: boolean } = {},
): boolean {
    const namesOrComponents = Array.isArray(nameOrComponent) ? nameOrComponent : [nameOrComponent];

    const predicate = (item: React.ReactNode) => {
        const elementDisplayName = getDisplayName(item);

        if (namesOrComponents.length === 0 || !elementDisplayName) return false;

        return namesOrComponents.some((nameOrComponentItem) => {
            const componentDisplayName = getDisplayName(nameOrComponentItem);

            if (nameOrComponentItem instanceof RegExp) {
                return nameOrComponentItem.test(elementDisplayName);
            }
            if (elementDisplayName === componentDisplayName) {
                return true;
            }
            return componentDisplayName.includes(`(${elementDisplayName})`);
        });
    };
    const matchingElement = findElement(element, predicate, {
        maxDepth: diveIntoChildren ? maxDepth : 0,
        onlySingleChildren,
    });
    return !!matchingElement;
}
